import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordStrengthService {
  // Función para evaluar la seguridad de la contraseña
  evaluatePasswordStrength(password: string): { strength: string, progress: number } {
    let strength = 'Seguridad Baja';
    let progress = 0;

    const lengthCriteria = password.length >= 8;
    const numberCriteria = /[0-9]/.test(password);
    const uppercaseCriteria = /[A-Z]/.test(password);
    const specialCharacterCriteria = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (lengthCriteria) progress += 25;
    if (numberCriteria) progress += 25;
    if (uppercaseCriteria) progress += 25;
    if (specialCharacterCriteria) progress += 25;

    if (progress >= 75) {
      strength = 'Seguridad Alta';
    } else if (progress >= 50) {
      strength = 'Seguridad Media';
    } else {
      strength = 'Seguridad Baja';
    }

    return { strength, progress };
  }
}
